<template>
  <!-- Шапка с параметрами в зависимости от страницы
  Передается: currentRoute = роут для отображения заголовка
  filter = true/false для отображения кнопки фильтра + @openModalFilter
  createBtn = true/false для отображения кнопки создания + @createElement -->
  <keep-alive>
    <top-navbar :currentRoute="$route"></top-navbar>
  </keep-alive>
  <section class="container-content">
    
    <!-- Объект с табами для переключения активной области отображения на странице -->
    <TabList 
      :tabs="tabs"
      @selectTab="selectTab"
    ></TabList>

    <!-- Области для отображения на основе выбранного таба -->
    <section v-if="activeTab == 'notifications'">
      <NotificationsComponent></NotificationsComponent>
    </section>
    <section v-else>
      <NotificationsHistoryComponent></NotificationsHistoryComponent>
    </section>

  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import TabList from "../components/TabList.vue";
import NotificationsComponent from "../components/NotificationsPage/Notifications.vue";
import NotificationsHistoryComponent from "../components/NotificationsPage/History.vue";
export default {
  name: 'NotificationsPage',
  components: {
    TopNavbar,
    TabList,
    NotificationsComponent,
    NotificationsHistoryComponent
  },
  data() {
    return {
      tabs: [
        {name: "notifications", title: "Уведомления"},
        {name: "history", title: "История событий"}
      ],
      activeTab: "notifications",
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // Активная таба
    selectTab(name) {
      this.activeTab = name
    },

    // Инициализация
    init() {
      // Получим заказы в data
      // console.log(this.data)
    },

    
  }
}
</script>
